import { SVGProps } from 'react'

const CloseIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M18 6L12 12M12 12L6 18M12 12L6 6M12 12L18 18"
            stroke={props?.color || '#1A1A1A'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default CloseIcon
